module.exports = __webpack_public_path__ + "static/media/step4.8a4f499a.svg";